import useAppStore from "../../stores";
import { DISPLAY_MAP } from "./constants";

export const useGetEntitlementsData = () => {
  const entitlements = useAppStore((state) => state.entitlements);
  const plan = useAppStore((state) => state.plan);
  return { entitlements, plan };
};

export const useAccessControlHook = (featureId) => {
  const entitlements = useAppStore((state) => state.entitlements);

  let state = DISPLAY_MAP.hide;

  if (featureId) {
    const value = entitlements?.[featureId];

    if (value === DISPLAY_MAP.show) {
      state = DISPLAY_MAP.show;
    } else if (value === DISPLAY_MAP.disable) {
      state = DISPLAY_MAP.disable;
    } else {
      state = DISPLAY_MAP.hide;
    }
  }

  return { hasPermissions: state };
};

export const useFeatureEnabled = (featureId) => {
  const entitlementsHydrated = useAppStore(
    (state) => state.entitlementsHydrated
  );
  const { hasPermissions } = useAccessControlHook(featureId);
  if (!entitlementsHydrated) return false;
  return hasPermissions === DISPLAY_MAP.show;
};
